export const experiencesData = [
  {
    id: 1,
    title: 'Gorilla Trekking Adventure',
    image: 'https://imgur.com/LUalhrs.jpg',
    location: 'Bwindi Impenetrable Forest',
    duration: '3 days',
    groupSize: '1-8 people',
    price: 1200,
    category: 'Wildlife',
    rating: 4.9,
    reviews: 127,
    description: 'Experience the thrill of encountering mountain gorillas in their natural habitat. This once-in-a-lifetime adventure takes you through the lush rainforests of Bwindi Impenetrable National Park, home to nearly half of the world\'s remaining mountain gorilla population.',
    highlights: [
      'Face-to-face encounter with endangered mountain gorillas',
      'Expert local guides and trackers',
      'Contribute to conservation efforts',
      'Breathtaking rainforest scenery',
      'Cultural interactions with local communities'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival & Cultural Experience',
        description: 'Arrive in Bwindi and check into your accommodation. Afternoon visit to a local Batwa community to learn about their traditional forest lifestyle and cultural practices. Evening briefing about the next day\'s gorilla trek followed by dinner and overnight stay at your lodge.'
      },
      {
        title: 'Day 2: Gorilla Trekking',
        description: 'Early breakfast followed by transfer to the park headquarters for briefing. Trek through the forest with experienced guides to find your assigned gorilla family (1-6 hours). Spend one magical hour observing the gorillas in their natural habitat. Return to the lodge for late lunch, relaxation, and sharing of experiences. Optional evening nature walk or spa treatment.'
      },
      {
        title: 'Day 3: Forest Walk & Departure',
        description: 'Morning guided forest walk to explore the biodiversity of Bwindi, including various primates, birds, and butterflies. Visit to the local community conservation project. After lunch, depart with a stop at the equator for photos before returning to your next destination.'
      }
    ],
    packingList: [
      'Sturdy hiking boots with good ankle support',
      'Long-sleeved shirts and long pants (neutral colors)',
      'Rain jacket or poncho (forest is often wet)',
      'Garden gloves for grabbing onto vegetation',
      'At least 2 liters of water',
      'Packed lunch and snacks',
      'Insect repellent and sunscreen',
      'Camera (no flash photography allowed with gorillas)',
      'Hiking poles (optional but recommended)',
      'Small backpack for personal items'
    ],
    locations: [
      {
        name: 'Bwindi Impenetrable National Park',
        description: 'A UNESCO World Heritage site in southwestern Uganda, home to approximately 400 mountain gorillas - nearly half of the world\'s remaining population.',
        coordinates: {
          lat: -1.0724,
          lng: 29.6777
        }
      },
      {
        name: 'Rushaga Sector',
        description: 'One of the four sectors of Bwindi where gorilla families can be tracked, known for having several habituated gorilla groups.',
        coordinates: {
          lat: -1.0371,
          lng: 29.6199
        }
      }
    ],
    faqs: [
      {
        question: 'How physically demanding is gorilla trekking?',
        answer: 'Gorilla trekking can be moderately to very challenging, depending on where the gorillas are located on the day of your trek. Treks can last from 1 to 6 hours through steep, muddy terrain. A reasonable level of fitness is required.'
      },
      {
        question: 'What are the chances of seeing gorillas?',
        answer: 'There is a 95% chance of seeing the gorillas. The trackers go out early before your trek begins to locate the gorilla families, significantly increasing your chances of an encounter.'
      },
      {
        question: 'How close do we get to the gorillas?',
        answer: 'You will be required to maintain a distance of at least 7 meters (about 23 feet) from the gorillas. However, sometimes the gorillas themselves may approach closer to you.'
      },
      {
        question: 'Is there an age restriction?',
        answer: 'Yes, you must be at least 15 years old to participate in gorilla trekking.'
      }
    ]
  },
  {
    id: 2,
    title: 'The Primates',
    image: 'https://imgur.com/eKHJjbW.jpg',
    location: 'Multiple Locations',
    duration: '4 days',
    groupSize: '1-8 people',
    price: 1600,
    category: 'Wildlife',
    rating: 4.8,
    reviews: 92,
    description: 'An immersive journey to observe Uganda\'s diverse primate species in their natural habitats, including chimpanzees, gorillas, and golden monkeys.',
    highlights: [
      'Gorilla tracking in Bwindi',
      'Chimpanzee trekking in Kibale',
      'Golden monkey tracking',
      'Multiple primate species observation',
      'Expert naturalist guides'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival & Kibale Forest',
        description: 'Arrive in Kibale National Park, known as the primate capital of the world. Evening briefing and overnight at lodge.'
      },
      {
        title: 'Day 2: Chimpanzee Tracking',
        description: 'Morning chimpanzee tracking in Kibale Forest. Afternoon nature walk to observe other primates and wildlife.'
      },
      {
        title: 'Day 3: Bwindi Forest',
        description: 'Transfer to Bwindi Impenetrable Forest. Evening cultural experience with local community.'
      },
      {
        title: 'Day 4: Gorilla Tracking',
        description: 'Morning gorilla tracking experience in Bwindi. Afternoon departure.'
      }
    ],
    packingList: [
      'Hiking boots',
      'Rain gear',
      'Camera equipment',
      'Binoculars',
      'Insect repellent',
      'Water bottle',
      'Snacks',
      'Sun protection'
    ],
    locations: [
      {
        name: 'Kibale National Park',
        description: 'Home to 13 primate species including chimpanzees',
        coordinates: {
          lat: 0.4636,
          lng: 30.3561
        }
      },
      {
        name: 'Bwindi Impenetrable Forest',
        description: 'Mountain gorilla sanctuary',
        coordinates: {
          lat: -1.0724,
          lng: 29.6777
        }
      }
    ],
    faqs: [
      {
        question: 'What fitness level is required?',
        answer: 'Moderate fitness level is needed for forest treks lasting 2-6 hours.'
      },
      {
        question: 'What is the best time to visit?',
        answer: 'June-September and December-February are the dry seasons, offering the best conditions.'
      }
    ]
  },
  {
    id: 3,
    title: 'Uganda Wonders',
    image: 'https://imgur.com/8u8WjGG.jpg',
    location: 'Multiple Parks',
    duration: '5 days',
    groupSize: '2-8 people',
    price: 1600,
    category: 'Safari',
    rating: 4.9,
    reviews: 85,
    description: 'A comprehensive tour showcasing Uganda\'s most spectacular natural wonders and wildlife.',
    highlights: [
      'Murchison Falls visit',
      'Game drives in multiple parks',
      'Boat safaris',
      'Cultural experiences',
      'Scenic landscapes'
    ],
    itinerary: [
      {
        title: 'Day 1: Murchison Falls',
        description: 'Travel to Murchison Falls National Park. Afternoon boat cruise to the falls base.'
      },
      {
        title: 'Day 2: Game Drive',
        description: 'Full-day game drive in the northern bank of Murchison Falls.'
      },
      {
        title: 'Day 3: Queen Elizabeth Park',
        description: 'Transfer to Queen Elizabeth National Park. Evening game drive.'
      },
      {
        title: 'Day 4: Kazinga Channel',
        description: 'Morning game drive and afternoon boat cruise on Kazinga Channel.'
      },
      {
        title: 'Day 5: Departure',
        description: 'Final game drive and departure.'
      }
    ],
    packingList: [
      'Safari clothing',
      'Camera gear',
      'Binoculars',
      'Sun protection',
      'Insect repellent'
    ],
    locations: [
      {
        name: 'Murchison Falls',
        description: 'World\'s most powerful waterfall',
        coordinates: {
          lat: 2.2742,
          lng: 31.6811
        }
      },
      {
        name: 'Queen Elizabeth National Park',
        description: 'Home to tree-climbing lions and diverse wildlife',
        coordinates: {
          lat: -0.1962,
          lng: 29.8897
        }
      },
      {
        name: 'Kazinga Channel',
        description: 'Natural channel connecting Lake Edward and Lake George',
        coordinates: {
          lat: -0.1333,
          lng: 29.9167
        }
      }
    ],
    faqs: [
      {
        question: 'What wildlife will we see?',
        answer: 'Expect to see elephants, lions, hippos, giraffes, and numerous bird species.'
      },
      {
        question: 'Is this tour suitable for children?',
        answer: 'Yes, children 6 and older can enjoy this safari. Special activities can be arranged for younger travelers.'
      },
      {
        question: 'What type of accommodation is included?',
        answer: 'We offer a range from mid-range to luxury lodges. All accommodations have private bathrooms and essential amenities.'
      }
    ]
  },
  {
    id: 4,
    title: 'Game Drives Uganda',
    image: 'https://imgur.com/WqH4Bly.jpg',
    location: 'Multiple Parks',
    duration: '4 days',
    groupSize: '2-6 people',
    price: 1200,
    category: 'Safari',
    rating: 4.7,
    reviews: 78,
    description: 'Experience Uganda\'s rich wildlife through expertly guided game drives in multiple national parks.',
    highlights: [
      'Multiple park game drives',
      'Professional wildlife guides',
      'Diverse ecosystems',
      'Photography opportunities',
      'Comfortable lodging'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival',
        description: 'Arrival and transfer to first park. Evening game drive.'
      },
      {
        title: 'Days 2-3: Game Drives',
        description: 'Full days of game drives in different parks.'
      },
      {
        title: 'Day 4: Departure',
        description: 'Morning game drive and departure.'
      }
    ],
    packingList: [
      'Safari attire',
      'Camera equipment',
      'Binoculars',
      'Sun protection'
    ],
    locations: [
      {
        name: 'Queen Elizabeth National Park',
        description: 'Uganda\'s most popular safari destination',
        coordinates: {
          lat: -0.1962,
          lng: 29.8897
        }
      },
      {
        name: 'Lake Mburo National Park',
        description: 'Compact safari park with diverse wildlife',
        coordinates: {
          lat: -0.6333,
          lng: 30.9667
        }
      }
    ],
    faqs: [
      {
        question: 'Best time for wildlife viewing?',
        answer: 'Dry seasons (June-September and December-February) offer the best visibility.'
      },
      {
        question: 'What animals might we see?',
        answer: 'Depending on the parks visited, you may see elephants, lions, leopards, buffaloes, giraffes, zebras, hippos, and various antelope species.'
      }
    ]
  },
  {
    id: 5,
    title: 'Into The Wild',
    image: 'https://imgur.com/0voUAaS.jpg',
    location: 'Multiple Locations',
    duration: '12 days',
    groupSize: '2-6 people',
    price: 4099,
    category: 'Adventure',
    rating: 4.9,
    reviews: 45,
    description: 'A comprehensive adventure through Uganda\'s most remote and pristine wilderness areas.',
    highlights: [
      'Remote park exploration',
      'Wildlife encounters',
      'Cultural experiences',
      'Adventure activities',
      'Luxury camping'
    ],
    itinerary: [
      {
        title: 'Days 1-3: Northern Parks',
        description: 'Explore remote northern parks and wildlife.'
      },
      {
        title: 'Days 4-6: Western Circuit',
        description: 'Adventure through western Uganda\'s wilderness.'
      },
      {
        title: 'Days 7-9: Southern Parks',
        description: 'Discover southern parks and communities.'
      },
      {
        title: 'Days 10-12: Eastern Region',
        description: 'Experience eastern Uganda\'s unique landscapes.'
      }
    ],
    packingList: [
      'Adventure gear',
      'Camping equipment',
      'First aid kit',
      'Navigation tools'
    ],
    locations: [
      {
        name: 'Kidepo Valley National Park',
        description: 'Remote wilderness in northeastern Uganda',
        coordinates: {
          lat: 3.8500,
          lng: 33.7500
        }
      },
      {
        name: 'Rwenzori Mountains',
        description: 'Uganda\'s "Mountains of the Moon"',
        coordinates: {
          lat: 0.3833,
          lng: 29.8667
        }
      },
      {
        name: 'Lake Bunyonyi',
        description: 'Second deepest lake in Africa with stunning scenery',
        coordinates: {
          lat: -1.2833,
          lng: 29.9167
        }
      }
    ],
    faqs: [
      {
        question: 'Physical requirements?',
        answer: 'Good fitness level required for extended wilderness activities.'
      },
      {
        question: 'Is camping comfortable?',
        answer: 'We provide luxury camping with proper beds, quality tents, and excellent meals prepared by our camp chef.'
      }
    ]
  },
  {
    id: 6,
    title: 'Wildlife Photography',
    image: 'https://imgur.com/Rl4EEiV.jpg',
    location: 'Various Parks',
    duration: '5 days',
    groupSize: '1-4 people',
    price: 1600,
    category: 'Photography',
    rating: 4.8,
    reviews: 56,
    description: 'Specialized tour for wildlife photography enthusiasts with expert guidance and prime shooting locations.',
    highlights: [
      'Professional photography guidance',
      'Prime wildlife locations',
      'Small group size',
      'Specialized vehicles',
      'Multiple species'
    ],
    itinerary: [
      {
        title: 'Day 1: Introduction',
        description: 'Photography workshop and equipment setup.'
      },
      {
        title: 'Days 2-4: Photo Shoots',
        description: 'Daily photography sessions in various locations.'
      },
      {
        title: 'Day 5: Final Shoot',
        description: 'Morning shoot and photo review session.'
      }
    ],
    packingList: [
      'Camera equipment',
      'Tripod',
      'Memory cards',
      'Cleaning kit'
    ],
    locations: [
      {
        name: 'Queen Elizabeth National Park',
        description: 'Prime photography location for diverse wildlife',
        coordinates: {
          lat: -0.1962,
          lng: 29.8897
        }
      },
      {
        name: 'Murchison Falls National Park',
        description: 'Excellent for landscape and wildlife photography',
        coordinates: {
          lat: 2.2742,
          lng: 31.6811
        }
      }
    ],
    faqs: [
      {
        question: 'Equipment requirements?',
        answer: 'DSLR/Mirrorless camera and telephoto lens recommended.'
      },
      {
        question: 'Can beginners join?',
        answer: 'Yes, our photography guides provide instruction for all skill levels.'
      }
    ]
  },
  {
    id: 7,
    title: 'Sipi Falls and Coffee Tour',
    image: 'https://imgur.com/8aMF2or.jpg',
    location: 'Sipi Falls',
    duration: '3 days',
    groupSize: '2-8 people',
    price: 300,
    category: 'Cultural',
    rating: 4.7,
    reviews: 64,
    description: 'Experience the beauty of Sipi Falls combined with an authentic coffee farming and processing tour.',
    highlights: [
      'Waterfall hikes',
      'Coffee plantation tour',
      'Coffee processing demonstration',
      'Local community interaction',
      'Mountain views'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival',
        description: 'Arrive at Sipi Falls. Afternoon short hike.'
      },
      {
        title: 'Day 2: Coffee Experience',
        description: 'Full day coffee tour and processing experience.'
      },
      {
        title: 'Day 3: Waterfall Hike',
        description: 'Morning waterfall hike and departure.'
      }
    ],
    packingList: [
      'Hiking shoes',
      'Rain jacket',
      'Camera',
      'Water bottle'
    ],
    locations: [
      {
        name: 'Sipi Falls',
        description: 'Series of three waterfalls on Mt. Elgon\'s slopes',
        coordinates: {
          lat: 1.3375,
          lng: 34.3750
        }
      },
      {
        name: 'Arabica Coffee Plantations',
        description: 'High-altitude coffee growing region',
        coordinates: {
          lat: 1.3300,
          lng: 34.3700
        }
      }
    ],
    faqs: [
      {
        question: 'Best time to visit?',
        answer: 'Year-round, but dry seasons offer better hiking conditions.'
      },
      {
        question: 'How difficult are the hikes?',
        answer: 'Moderate difficulty with some steep sections. Basic fitness required.'
      }
    ]
  },
  {
    id: 8,
    title: 'The Big Five Safari',
    image: 'https://imgur.com/apzhfcl.jpg',
    location: 'Multiple Parks',
    duration: '7 days',
    groupSize: '2-6 people',
    price: 2200,
    category: 'Safari',
    rating: 4.9,
    reviews: 82,
    description: 'Experience Uganda\'s ultimate wildlife safari as you track all members of the Big Five—Lions, Elephants, Leopards, Buffalos, and Rhinos. This trip combines game drives, river safaris, and guided walks for unparalleled animal encounters.',
    highlights: [
      'Track all Big Five animals',
      'Multiple national parks',
      'River and land safaris',
      'Expert wildlife guides',
      'Comfortable lodging'
    ],
    itinerary: [
      {
        title: 'Day 1: Ziwa Rhino Sanctuary',
        description: 'Arrival & transfer to Ziwa Rhino Sanctuary – Rhino tracking experience'
      },
      {
        title: 'Day 2: Murchison Falls',
        description: 'Transfer to Murchison Falls – Evening game drive'
      },
      {
        title: 'Day 3: Murchison Activities',
        description: 'Morning game drive & boat safari on the Nile'
      },
      {
        title: 'Day 4: Queen Elizabeth',
        description: 'Transfer to Queen Elizabeth – Kazinga Channel boat cruise'
      },
      {
        title: 'Day 5: Lake Mburo Transfer',
        description: 'Game drive & transfer to Lake Mburo National Park'
      },
      {
        title: 'Day 6: Lake Mburo Activities',
        description: 'Safari walk, cycling, or horse riding in Lake Mburo'
      },
      {
        title: 'Day 7: Return Journey',
        description: 'Return to Kampala'
      }
    ],
    packingList: [
      'Safari clothing (neutral colors)',
      'Comfortable walking shoes',
      'Camera equipment',
      'Binoculars',
      'Sun protection',
      'Insect repellent',
      'Water bottle',
      'Light jacket'
    ],
    locations: [
      {
        name: 'Ziwa Rhino Sanctuary',
        description: 'Home to Uganda\'s only wild rhinos',
        coordinates: {
          lat: 1.8000,
          lng: 32.4500
        }
      },
      {
        name: 'Murchison Falls National Park',
        description: 'Uganda\'s largest national park with diverse wildlife',
        coordinates: {
          lat: 2.2742,
          lng: 31.6811
        }
      },
      {
        name: 'Queen Elizabeth National Park',
        description: 'Famous for tree-climbing lions and diverse ecosystems',
        coordinates: {
          lat: -0.1962,
          lng: 29.8897
        }
      },
      {
        name: 'Lake Mburo National Park',
        description: 'Compact park with zebras and impalas',
        coordinates: {
          lat: -0.6333,
          lng: 30.9667
        }
      }
    ],
    faqs: [
      {
        question: 'Are all Big Five animals guaranteed?',
        answer: 'Yes, with rhinos at Ziwa and leopards in Queen Elizabeth.'
      },
      {
        question: 'Can I upgrade accommodations?',
        answer: 'Yes, luxury lodges are available.'
      }
    ]
  },
  {
    id: 9,
    title: 'Uganda Birdwatching Safari',
    image: 'https://imgur.com/7qDwljW.jpg',
    location: 'Multiple Locations',
    duration: '10 days',
    groupSize: '2-6 people',
    price: 2800,
    category: 'Birding',
    rating: 4.8,
    reviews: 45,
    description: 'Uganda is a birdwatcher\'s paradise, home to over 1,000 bird species! This tour takes you through wetlands, forests, and savannahs to spot the Shoebill Stork, Great Blue Turaco, Green-breasted Pitta, and more.',
    highlights: [
      'Over 1,000 bird species',
      'Multiple ecosystems',
      'Expert birding guides',
      'Photography opportunities',
      'Comfortable lodging'
    ],
    itinerary: [
      {
        title: 'Day 1: Mabamba Swamp',
        description: 'Arrival & Mabamba Swamp birding tour (Shoebill Stork)'
      },
      {
        title: 'Day 2-3: Murchison Falls',
        description: 'Transfer to Murchison Falls – Evening birding walk, Game drive & boat safari focusing on water birds'
      },
      {
        title: 'Day 4-5: Kibale Forest',
        description: 'Transfer to Kibale – Birding in Bigodi Wetlands, Chimpanzee trekking & forest birdwatching'
      },
      {
        title: 'Day 6: Queen Elizabeth',
        description: 'Transfer to Queen Elizabeth – Birding along the Kazinga Channel'
      },
      {
        title: 'Day 7-8: Bwindi Forest',
        description: 'Transfer to Bwindi – Birdwatching en route, Full-day forest birding in Bwindi'
      },
      {
        title: 'Day 9: Lake Mburo',
        description: 'Birding in Lake Mburo National Park'
      },
      {
        title: 'Day 10: Return',
        description: 'Return to Kampala'
      }
    ],
    packingList: [
      'Binoculars',
      'Bird field guide',
      'Camera equipment',
      'Waterproof gear',
      'Hiking boots',
      'Neutral clothing'
    ],
    locations: [
      {
        name: 'Mabamba Swamp',
        description: 'Prime location for spotting the elusive Shoebill',
        coordinates: {
          lat: 0.1167,
          lng: 32.3500
        }
      },
      {
        name: 'Bigodi Wetland Sanctuary',
        description: 'Community-run sanctuary with diverse bird species',
        coordinates: {
          lat: 0.4833,
          lng: 30.3667
        }
      },
      {
        name: 'Bwindi Impenetrable Forest',
        description: 'Home to numerous forest bird species',
        coordinates: {
          lat: -1.0724,
          lng: 29.6777
        }
      }
    ],
    faqs: [
      {
        question: 'Best time for birding?',
        answer: 'November–April for migratory birds; June–September for resident birds.'
      },
      {
        question: 'What gear do I need?',
        answer: 'Binoculars, camera, and field guidebook.'
      }
    ]
  },
  {
    id: 10,
    title: 'Uganda Luxury Safari & Gorilla Trekking',
    image: 'https://imgur.com/8xxc0ZF.jpg',
    location: 'Multiple Parks',
    duration: '8 days',
    groupSize: '2-6 people',
    price: 5000,
    category: 'Luxury',
    rating: 4.9,
    reviews: 38,
    description: 'A high-end luxury safari that blends wildlife, comfort, and exclusivity. Stay in 5-star lodges, take a private gorilla trek, and enjoy VIP game drives.',
    highlights: [
      'Luxury accommodations',
      'Private charter flights',
      'Exclusive experiences',
      'Personal guide',
      'Gourmet dining'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival',
        description: 'Arrival & Kampala city tour'
      },
      {
        title: 'Day 2: Murchison Falls',
        description: 'Private charter flight to Murchison Falls – Luxury game drive'
      },
      {
        title: 'Day 3: Exclusive Activities',
        description: 'Exclusive boat cruise & evening sundowner'
      },
      {
        title: 'Day 4: Kibale Forest',
        description: 'Transfer to Kibale – Chimpanzee tracking'
      },
      {
        title: 'Day 5: Queen Elizabeth',
        description: 'Transfer to Queen Elizabeth – Private game drive & boat cruise'
      },
      {
        title: 'Day 6: Bwindi',
        description: 'Fly to Bwindi – Luxury gorilla trekking experience'
      },
      {
        title: 'Day 7: Relaxation',
        description: 'Relaxation day at a top eco-lodge in Bwindi'
      },
      {
        title: 'Day 8: Departure',
        description: 'Private charter flight back to Entebbe'
      }
    ],
    packingList: [
      'Casual luxury wear',
      'Safari attire',
      'Camera equipment',
      'Sun protection',
      'Evening wear'
    ],
    locations: [
      {
        name: 'Sanctuary Gorilla Forest Camp',
        description: 'Luxury tented camp in Bwindi Forest',
        coordinates: {
          lat: -1.0500,
          lng: 29.6700
        }
      },
      {
        name: 'Chobe Safari Lodge',
        description: 'Luxury lodge overlooking the Nile River',
        coordinates: {
          lat: 2.1500,
          lng: 31.5500
        }
      },
      {
        name: 'Kyambura Gorge Lodge',
        description: 'Eco-luxury lodge near Queen Elizabeth National Park',
        coordinates: {
          lat: -0.1800,
          lng: 30.0500
        }
      }
    ],
    faqs: [
      {
        question: 'What makes this trip luxurious?',
        answer: 'Private guides, chartered flights, and top-tier lodges.'
      },
      {
        question: 'Can families join?',
        answer: 'Yes, with custom itineraries for kids.'
      }
    ]
  },
  {
    id: 11,
    title: 'Kidepo Wilderness Safari',
    image: 'https://imgur.com/jLwqpmS.jpg',
    location: 'Kidepo Valley',
    duration: '6 days',
    groupSize: '2-6 people',
    price: 1800,
    category: 'Safari',
    rating: 4.9,
    reviews: 32,
    description: 'For travelers seeking raw, untouched wilderness, Kidepo Valley offers incredible wildlife, cultural experiences with the Karamojong people, and breathtaking landscapes.',
    highlights: [
      'Remote wilderness',
      'Unique wildlife',
      'Cultural experiences',
      'Scenic landscapes',
      'Exclusive safari'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival',
        description: 'Arrival & flight/drive to Kidepo'
      },
      {
        title: 'Day 2: Game Drive',
        description: 'Full-day game drive in Kidepo\'s vast savannah'
      },
      {
        title: 'Day 3: Cultural Visit',
        description: 'Walking safari & cultural visit to the Karamojong villages'
      },
      {
        title: 'Day 4: Sunrise Safari',
        description: 'Sunrise game drive & scenic picnic breakfast'
      },
      {
        title: 'Day 5: Optional Activities',
        description: 'Leisure day – optional hot springs visit'
      },
      {
        title: 'Day 6: Departure',
        description: 'Flight/drive back to Entebbe'
      }
    ],
    packingList: [
      'Safari clothing',
      'Walking shoes',
      'Camera equipment',
      'Sun protection',
      'Insect repellent'
    ],
    locations: [
      {
        name: 'Kidepo Valley National Park',
        description: 'Remote wilderness in northeastern Uganda',
        coordinates: {
          lat: 3.8500,
          lng: 33.7500
        }
      },
      {
        name: 'Karamojong Villages',
        description: 'Traditional pastoral communities',
        coordinates: {
          lat: 3.1167,
          lng: 33.9167
        }
      },
      {
        name: 'Kanangorok Hot Springs',
        description: 'Natural hot springs near the Sudan border',
        coordinates: {
          lat: 3.9500,
          lng: 33.8333
        }
      }
    ],
    faqs: [
      {
        question: 'How remote is Kidepo?',
        answer: 'One of Africa\'s most isolated but stunning parks.'
      },
      {
        question: 'Are flights available?',
        answer: 'Yes, chartered flights can be arranged.'
      }
    ]
  },
  {
    id: 12,
    title: 'Great Apes of Uganda Safari',
    image: 'https://imgur.com/HE1ci9r.jpg',
    location: 'Multiple Parks',
    duration: '7 days',
    groupSize: '2-6 people',
    price: 3200,
    category: 'Wildlife',
    rating: 4.8,
    reviews: 42,
    description: 'A specialized tour for primate lovers, tracking mountain gorillas, chimpanzees, and golden monkeys in Uganda\'s pristine forests.',
    highlights: [
      'Gorilla trekking',
      'Chimpanzee tracking',
      'Golden monkey viewing',
      'Forest walks',
      'Multiple primate species'
    ],
    itinerary: [
      {
        title: 'Day 1: Arrival',
        description: 'Arrival & transfer to Kibale'
      },
      {
        title: 'Day 2: Chimpanzees',
        description: 'Chimpanzee trekking in Kibale'
      },
      {
        title: 'Day 3: Queen Elizabeth',
        description: 'Transfer to Queen Elizabeth – Boat safari'
      },
      {
        title: 'Day 4: Bwindi',
        description: 'Transfer to Bwindi – Gorilla trekking experience'
      },
      {
        title: 'Day 5: Mgahinga',
        description: 'Transfer to Mgahinga – Golden Monkey tracking'
      },
      {
        title: 'Day 6: Optional Hike',
        description: 'Hike to Sabyinyo Volcano (optional)'
      },
      {
        title: 'Day 7: Return',
        description: 'Return to Entebbe'
      }
    ],
    packingList: [
      'Hiking boots',
      'Rain gear',
      'Camera equipment',
      'Trekking clothes',
      'Permits'
    ],
    locations: [
      {
        name: 'Kibale National Park',
        description: 'Home to 13 primate species including chimpanzees',
        coordinates: {
          lat: 0.4636,
          lng: 30.3561
        }
      },
      {
        name: 'Bwindi Impenetrable Forest',
        description: 'Mountain gorilla sanctuary',
        coordinates: {
          lat: -1.0724,
          lng: 29.6777
        }
      },
      {
        name: 'Mgahinga Gorilla National Park',
        description: 'Home to golden monkeys and part of Virunga volcanoes',
        coordinates: {
          lat: -1.3833,
          lng: 29.6333
        }
      }
    ],
    faqs: [
      {
        question: 'Can I combine gorillas & chimps in one trip?',
        answer: 'Yes, this itinerary does just that!'
      },
      {
        question: 'Do I need separate permits?',
        answer: 'Yes, but all are included in the package.'
      }
    ]
  }
];